// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"bd30f42e","303":"882bcfc0","482":"4b8a6d42","511":"2c5d5542","516":"9cda4510","526":"61036764","594":"61bf558e","713":"c49de923"}[chunkId] + ".chunk.js";
};